

class CommentsPanel extends BaseInfoPanel {

	constructor() {
		super();

		this.view();
	}


	protected view() {
		this.frag = document.createDocumentFragment();
		this.frag.appendChild(document.createTextNode('comments here :)'));
	}

}